<div class="buttons-over-form mb-3">
  <app-back-button></app-back-button>
</div>
<div class="container-box">
  <div class="detail-page">
    <!-- Header -->
    <div class="detail-header">
      <div class="header-left">
        <div class="header-icon">
          <i class="fas fa-shield-alt"></i>
        </div>
        <div class="header-info">
          <h2 class="page-title">
            Polizza {{ data?.tipoAssicurazione }}
            <span class="policy-number" *ngIf="data?.numeroPolizza">
              N. {{ data?.numeroPolizza }}
            </span>
          </h2>
          <span class="company-name" *ngIf="data?.compagnia">{{ data?.compagnia }}</span>
        </div>
      </div>
      <div class="header-right">
        <!-- Status Badge -->
        <span
          *ngIf="data?.stato"
          class="status-badge"
          [ngClass]="{
            'status-badge--active': data.stato === 'ATTIVA',
            'status-badge--suspended': data.stato === 'SOSPESA',
            'status-badge--expired': data.stato === 'SCADUTA'
          }"
        >
          <i
            class="fas"
            [ngClass]="{
              'fa-check-circle': data.stato === 'ATTIVA',
              'fa-pause-circle': data.stato === 'SOSPESA',
              'fa-times-circle': data.stato === 'SCADUTA'
            }"
          ></i>
          {{ data.stato }}
        </span>
      </div>
    </div>

    <!-- Info Cards Row -->
    <div class="info-row" *ngIf="data?.dataInizio">
      <div class="info-card">
        <span class="info-label">Data inizio</span>
        <span class="info-value">{{ data.dataInizio | date: 'dd/MM/yyyy':'':'it-IT' }}</span>
      </div>
      <div class="info-card">
        <span class="info-label">Data fine</span>
        <span class="info-value">{{ data.dataFine | date: 'dd/MM/yyyy':'':'it-IT' }}</span>
      </div>
      <div class="info-card" *ngIf="data?.rc">
        <span class="info-label">RC</span>
        <span class="info-value">{{ data.rc }}</span>
      </div>
      <div class="info-card" *ngIf="data?.ifk">
        <span class="info-label">IFK</span>
        <span class="info-value">{{ data.ifk }}</span>
      </div>
      <div class="info-card" *ngIf="data?.pai">
        <span class="info-label">PAI</span>
        <span class="info-value">{{ data.pai }}</span>
      </div>
    </div>

    <!-- Document Actions -->
    <div class="doc-actions">
      <button *ngIf="showButtonUploadFile()" class="doc-btn doc-btn--upload" (click)="uploadFile()">
        <i class="fas fa-cloud-upload-alt"></i>
        Allega PDF Polizza
      </button>
      <button *ngIf="data?.file" class="doc-btn doc-btn--download" (click)="downloadFile()">
        <i class="fas fa-file-pdf"></i>
        Scarica PDF Polizza
      </button>
    </div>

    <!-- Alerts -->
    <div *ngIf="data?.tipoAssicurazione === 'SINGOLA'" class="alert-box alert-box--info">
      <i class="fas fa-info-circle"></i>
      <p>
        Per le polizze di tipo
        <strong>SINGOLA</strong>
        è consentita una sola associazione
        <strong>ATTIVA</strong>
        alla volta; il pulsante "Associa veicolo" potrebbe non essere visibile se è già presente un
        veicolo assicurato attivo.
      </p>
    </div>
    <div *ngIf="data?.tipoAssicurazione === 'TARGA_PROVA'" class="alert-box alert-box--warning">
      <i class="fas fa-exclamation-triangle"></i>
      <p>
        Per le polizze di tipo
        <strong>TARGA PROVA</strong>
        le associazioni con i veicoli non vengono gestite da questa schermata; per questo non è
        presente il tab "Veicoli Assicurati".
      </p>
    </div>

    <!-- Tabs -->
    <mat-tab-group animationDuration="0ms" class="detail-tabs">
      <mat-tab *ngFor="let tab of tabs">
        <ng-template mat-tab-label>
          <fa-icon [icon]="faIcon"></fa-icon>
          {{ tab.title }}
        </ng-template>
        <div *ngIf="tab.title === 'Dettaglio'" class="tab-content">
          <app-insurance-form [data]="data"></app-insurance-form>
        </div>
        <div *ngIf="tab.title === 'Veicoli Assicurati'" class="tab-content">
          <div class="vehicles-header">
            <h3 class="vehicles-title">
              <i class="fas fa-car"></i>
              Lista Veicoli Assicurati
              {{ data?.tipoAssicurazione === 'MULTIPLA' ? ' - LIBRO MATRICOLA' : '' }}
            </h3>
            <app-button
              (btnClicked)="linkInsurance()"
              *ngIf="showButtonNewAssociation()"
              [color]="'primary'"
              [content]="'Associa veicolo'"
              [faIcon]="faPlus"
              [showIcon]="true"
              [toolTip]="'Associa veicolo da assicurare'"
            ></app-button>
          </div>
          <app-new-table
            *ngIf="dataSource !== null"
            [customButtons]="customButtons"
            [dataSource]="dataSource"
            [displayedColumns]="displayedColumns"
            [initialSort]="{ active: 'dataFine', direction: 'desc' }"
            [reloadTrigger$]="reloadTrigger$"
            [showElementsPerPage]="true"
            [showPaginate]="true"
          ></app-new-table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
